/**
 * Gets the current access token fresh from session storage every time,
 * so we never serve a stale token after Okta's autoRenew updates it.
 * @returns {string|null} The access token if available, otherwise null.
 */
export const getToken = () => {
  const storedData = sessionStorage.getItem("okta-token-storage");
  if (storedData) {
    try {
      const tokenData = JSON.parse(storedData);
      return tokenData?.accessToken?.accessToken || null;
    } catch (error) {
      return null;
    }
  }
  return null;
};

/**
 * @deprecated No longer needed — getToken() now reads fresh from sessionStorage every time.
 * Kept for backward compatibility with existing call sites.
 */
export const updateToken = () => {
  // no-op
};
